import SimpleImageTool from "@/editorjs/tools/simple-image/index";
import api from "@/utils/api";
import { isValidImageUrl } from '@/editorjs/utils';

export default class GalleryTool extends SimpleImageTool {

    constructor({data, config, api, readOnly, block}) {
        super({data, config, api, readOnly, block});
    }

    appendDefault(data) {
        this.onUpload({
            success: 1,
            file: { url: data.file.url} // TODO Tune, Link 등의 나머지도 작업 필요
        });
    }

    // 기존에 파일 업로드 자동으로 오픈하는 block 의 rendering 콜백
    appendCallback() {

    }

    render() {
        const wrapper = document.createElement('div');
        const defaultRender = this.ui.render(this.data);

        if (!(this.data.file.url && isValidImageUrl(this.data.file.url)) && this.config.endpoints.prefetch) {
            const galleryContainer = document.createElement('div');
            galleryContainer.className = "cdx-button gallery-container";

            if (this.config.endpoints.prefetch === "demo") {
                Array.from(
                    ["https://picsum.photos/id/110/640/320", "https://picsum.photos/id/42/640/320"]
                ).forEach((image_url) => {
                    const image = document.createElement('img');
                    image.src = image_url;
                    image.addEventListener('click', () => {
                        return this.appendDefault(image_url)
                    });
                    galleryContainer.appendChild(image);
                });

                defaultRender.appendChild(galleryContainer);
            } else {
                api.post(this.config.endpoints.prefetch).then((response) => {
                    const imageUrls = response.data;

                    if (imageUrls && imageUrls.length > 0) {
                        Array.from(imageUrls).forEach((data) => {
                            const image = document.createElement('img');
                            image.src = data.file.url;
                            image.addEventListener('click', () => {
                                return this.appendDefault(data)
                            });
                            galleryContainer.appendChild(image);
                        });

                        defaultRender.appendChild(galleryContainer);
                    }
                });
            }
        }

        wrapper.appendChild(defaultRender);

        return wrapper;
    }

}